import { useUpdateProfileList } from '@/entities/saved-creators-list';
import { Button } from '@/shared/components/shadcn/button';
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/shared/components/shadcn/dialog';
import { Input } from '@/shared/components/shadcn/input';
import { useState } from 'react';

type Props = {
  currentTitle: string;
  listId: string;
  close: () => void;
};

export const EditListNameDialog = ({ currentTitle, listId, close }: Props) => {
  const [newTitle, setNewTitle] = useState(currentTitle);
  const updateTitleMutation = useUpdateProfileList();

  const onSubmit = async () => {
    await updateTitleMutation.mutateAsync({
      listId: listId,
      title: newTitle,
    });
    close();
  };

  return (
    <Dialog open={true} onOpenChange={close}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Edit list name</DialogTitle>
        </DialogHeader>
        <div className="flex flex-col gap-2">
          <label className="text-sm">Title</label>
          <Input value={newTitle} onChange={(e) => setNewTitle(e.target.value)} />
        </div>
        <DialogFooter>
          <Button variant="secondary" onClick={close}>
            Close
          </Button>
          <Button onClick={onSubmit}>Save</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
